import { createApiCall } from 'lib/base';

const CREATE_HOME_WIDGET_MENU_ITEM = 'CREATE_HOME_WIDGET_MENU_ITEM';

const createHomeWidgetMenuItemApi = createApiCall<{ payload: any }>(
  CREATE_HOME_WIDGET_MENU_ITEM,
  ({ payload }) => ({
    endpoint: `api/admin/home-widget-menu-items`,
    method: 'POST',
    body: payload,
  })
);

export default createHomeWidgetMenuItemApi;
